<template>
    <el-drawer
      title="配置"
      :visible.sync="drawer"
      direction="rtl"
      :modal="false"
      :wrapperClosable="false"
      :modal-append-to-body="false"
      size="20%"
      :append-to-body="true">

      <el-tabs style="margin-left: 20px;" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="type == 'picture' || type == 'line'" label="颜色配置" name="1">
          <!-- 颜色配置 -->
          <div style="display: flex;justify-content: center;text-align: center;flex-direction: column;">
            <div class="title">编辑信息</div>
            <div class="box" v-if="type == 'picture'">
              <span>背景颜色</span>
              <input type="color" name="bgColor" @input="color($event,1)" ref="bacolor" id="bgColor">
            </div>
            <div class="box">
              <span>边框颜色</span>
              <input type="color" name="bgColor" @input="color($event,2)" ref="bacolor" id="bgColor">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="type != 'picture' && type != 'line'" label="设备绑定" name="2">设备绑定</el-tab-pane>
      </el-tabs>
      <div class="footer">
        <el-button type="primary" @click="oper(1)" round>确定</el-button>
        <el-button round @click="oper(2)">恢复默认</el-button>
        <el-button type="danger" @click="oper(3)" round>删除</el-button>
      </div>
      
    </el-drawer>
   
</template>

<script>

export default {
  data() {
    return {
      drawer:false,
      borderColor:'',
      backColor:'',
      data:'',
      edit:'',
      activeName: '1',
      type:'',
      graph:'',
      
    }
  },
  methods:{
    color(e,index){
      if(index == 1){
          this.edit.attr('body/fill',e.target.value)
      }else if(index == 2){
        if(this.edit.store.data.type == 'picture'){
          this.edit.attr('body/stroke',e.target.value)
        }else{
          console.log("测试",this.edit.getData())
          this.edit.setData({
            borderColor:e.target.value
          })
        }
      }
    },
    setDrawer(drawer,edit,graph){
      console.log("打开",edit);
      this.drawer = drawer;
      this.type = edit.store.data.type;
      this.edit = edit;
      this.graph = graph;
    },
    handleClick(tab, event) {
          console.log(tab, event);
        },
    oper(index){
      switch(index){
        case 1:
          this.drawer = false;
        break;
        case 2:
        this.edit.attr('body/fill','rgba(0,0,0,0.0001)')
          if(this.edit.store.data.type == 'picture'){
            this.edit.attr('body/stroke','rgb(151, 151, 151)')
          }else{
            console.log("测试",this.edit.getData())
            this.edit.setData({
              borderColor:'rgb(151, 151, 151)'
            })
          }
          this.drawer = false;
        break;
        case 3:
          this.$alert('确定删除节点嘛', '删除', {
            confirmButtonText: '确定',
            callback: action => {
              // let cell = this.graph.getSelectedCells()
              // this.graph.cut(cell);
              this.graph.removeNode(this.edit)
              this.drawer = false;
            }
          });
        break;
      }
    }
    },
    
}
</script>

<style scoped>
  .box{
    width: 60%;
    margin-left: 20%;
    margin-top: 20%;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .footer{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom:10%;
  }
  .title{
    /* font-weight: ; */
    margin-top: 10%;
    font-size: 30px;
  }
</style>